import { faGear } from '@fortawesome/free-solid-svg-icons';
import { ListItemText } from '@mui/material';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { NavLink } from 'react-router';

import { menusSlice } from '»components/Menus/_menus.slice';
import {
  getActiveMenuItemSelector,
  getActiveNavigationMenuItemSelector,
  isMenuOpened,
} from '»components/Menus/menus.selectors';

import {
  FontAwesomeIconStyled,
  ListItemIconStyled,
  RootListItemButtonStyled,
} from '../../Menu.styles';

export const SettingsMenuItem = () => {
  const dispatch = useDispatch();

  const activeMenuItem = useSelector(getActiveMenuItemSelector);
  const activeNavigationMenuItem = useSelector(
    getActiveNavigationMenuItemSelector,
  );
  const isOpen = useSelector(isMenuOpened);

  const OPTION_ID = 'SETTINGS';
  const handleClickLeafMenu = (menuItem) => {
    dispatch(
      menusSlice.actions.setActiveMenuItem({ activeMenuItem: menuItem }),
    );
    dispatch(
      menusSlice.actions.setActiveNavigationMenuItem({
        activeNavigationMenuItem: '',
      }),
    );
  };
  return (
    <RootListItemButtonStyled
      onClick={() => handleClickLeafMenu(OPTION_ID)}
      component={NavLink}
      to="/Settings"
      selected={activeMenuItem?.includes(OPTION_ID)}
      isActiveNavigationMenuItemEmpty={activeNavigationMenuItem === ''}
      isOpen={isOpen}
      id="btnMenuSettings"
    >
      <ListItemIconStyled>
        <FontAwesomeIconStyled
          icon={faGear}
          selected={activeMenuItem?.includes(OPTION_ID)}
        />
      </ListItemIconStyled>
      <ListItemText primary={<FormattedMessage id="TRLT_UI-SETTINGS" />} />
    </RootListItemButtonStyled>
  );
};
SettingsMenuItem.propTypes = {
  isOpen: PropTypes.bool,
  activeMenuItem: PropTypes.string,
  activeNavigationMenuItem: PropTypes.string,
  setActiveMenuItem: PropTypes.func,
  setActiveNavigationMenuItem: PropTypes.func,
};
